module.exports = __webpack_public_path__ + "img/dcom09.ef68b118.png";